"use client";

import { useCollectionData } from "../../../hooks/useCollectionData";
import { useStore } from "@/hooks/system/useStore";
import S from "./index.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import clsx from "clsx";

const CategoriesTabs = () => {
  const { detailCollection } = useCollectionData();
  const { selectedFilters, setSelectedFilters } = useStore("collection");

  const categoryHandler = (category: number) => {
    setSelectedFilters({ category_id: category, page_number: 1 });
  };

  if (!detailCollection.detailCollection || !detailCollection.detailCollection.categories?.length) return null;

  return (
    <div className={S.tabsList}>
      <div className={S.categoryWrapper}>
        <Swiper slidesPerView={"auto"} spaceBetween={40} freeMode loop={false}>
          {detailCollection.detailCollection.categories.map(({ id, title }) => (
            <SwiperSlide className={S.categorySlider} key={id}>
              <button
                onClick={() => categoryHandler(id)}
                className={clsx(S.categoryTab, {
                  [S["categoryTab--active"]]: selectedFilters.category_id === id,
                })}
              >
                {title}
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default CategoriesTabs;
